import { useEffect } from "react";
import { useSelector } from "react-redux";
import { SigninForm } from "components/forms/signIn";
import { useLocation, useNavigate } from "react-router-dom";

const Signin = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { user } = useSelector((state) => state.auth);
    const pathname = location.pathname.toLowerCase();
    const role = pathname.includes("editor")
        ? "editor"
        : pathname.includes("subadmin")
            ? "subAdmin"
            : "superAdmin";

    // Redirect authenticated users away from login
    useEffect(() => {
        if (user) {
            if (user.isSuperAdmin || user.role === "superAdmin") {
                navigate("/dashboard", { replace: true });
            } else {
                navigate("/cms", { replace: true });
            }
        }
    }, [user, navigate]);

    return <SigninForm role={role} />;
};

export default Signin;
